import { Module, Action, getModule } from 'vuex-module-decorators';
import PageBaseModule from '@/store/page';
import store from '@/store';
import PageEntity from '@/store/pageEntity';

import StoriesFilter from './filterEntity';
import { Filter } from '@/types/filter/filter';
import filterModel from './filterModel';

import { getList } from '@/api/crud';
import ResponseHandlerModule from '@/store/modules/responseHandler';

import { Stories } from '@/models/stories';

export const MODULE_NAME = Stories.moduleName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class StoriesModule extends PageBaseModule {
    filter: Filter;

    constructor(module: StoriesModule) {
        super(module);

        const page = new PageEntity();
        page.setModuleName(Stories.moduleName);
        page.setTitle(Stories.listTitle);
        page.setTitleAdd(Stories.createTitle);
        page.values.actionPagination = 'stories/updatePage';
        page.values.actionPageAmountItems = 'stories/updatePageAmountItems';
        page.values.pageAmountItems = 50;
        this.pageSettings = page.values;
        this.pageSettings.routeName = `${Stories.moduleName}_edit`;
        this.pageSettings.routeParam = `${Stories.moduleName}Id`;

        const filter = new filterModel();
        this.filter = getModule(StoriesFilter);
        this.filter.setFilterName('storiesFilter');
        this.filter.setTemplateClassName('template-lg');
        this.filter.setFilterModel(filter.filterModel);
        this.filter.setFilterHandlers(filter.filterHandlers);
    }

    @Action({ rawError: true })
    async init() {
        await this.getList();
    }

    @Action({ rawError: true })
    async getList() {
        try {
            const sort = await this.getSortForRequest();
            const result = await getList(
                Stories.apiPrefix,
                {
                    page: this.pageSettings.pageCurrent,
                    items: this.pageSettings.pageAmountItems,
                },
                sort,
                this.filter.filterSettings.filter,
            );
            await this.context.dispatch('setList', result.table);
        } catch (clientError: any) {
            const error = clientError.response.data;

            ResponseHandlerModule.showNotify({ message: error.message, type: 'fail' });

            await this.context.dispatch('updatePage', 1);
        }
    }
}

export default getModule(StoriesModule);
